import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons/faTimesCircle";
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faGiftCard } from "@fortawesome/pro-light-svg-icons/faGiftCard";
import ReactGA from "react-ga";
import styles from "../../styles/presentational/selectedCharities.css";

export class SelectedCharities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          styles.main +
          (this.props.selectedCharities.length > 0 ? "" : " " + styles.empty)
        }
      >
        <div
          className={
            styles.message + (this.props.collapse ? " " + styles.hide : "")
          }
        >
          {this.props.dictionary.selected_charities_header}
        </div>
        <ul
          className={
            styles.list + (this.props.collapse ? " " + styles.hideSmall : "")
          }
        >
          {this.props.selectedCharities.map((charity, index) => {
            return (
              <li key={index} className={styles.selected}>
                <div className={styles.name}>
                  {index + 1 + ". " + charity.name}
                  <div
                    className={styles.remove}
                    onClick={() => {
                      ReactGA.event({
                        category: "User Action",
                        action: "Clicked Remove Charity",
                        label: "/Spend/Presentational/SelectedCharities",
                      });
                      this.props.onRemoveCharity(charity.ein);
                    }}
                  >
                    <FontAwesomeIcon
                      className={styles.icon}
                      icon={faTimesCircle}
                    />
                  </div>
                </div>
              </li>
            );
          })}
          {this.props.selectedCharities.length < 1 ? (
            <li>
              <div className={styles.name}>
                {"1. " + this.props.dictionary.selected_charities_required}
              </div>
            </li>
          ) : null}
          {[...Array(this.props.additionalCharityCount)].map((x, i) => {
            if (this.props.selectedCharities.length < i + 2) {
              return (
                <li key={i}>
                  <div className={styles.name}>
                    {i +
                      2 +
                      ". " +
                      this.props.dictionary.selected_charities_optional}
                  </div>
                </li>
              );
            }
          })}
        </ul>
        <div className={styles.commands}>
          <button
            className={
              styles.button +
              (this.props.selectedCharities.length > 0
                ? " " + styles.active
                : "")
            }
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Continue Button",
                label: "/Spend/Presentational/SelectedCharities",
              });
              this.props.onContinue();
            }}
          >
            {this.props.dictionary.selected_charities_continue}
          </button>
          <button
            className={styles.collapse + " " + styles.button}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Collapse " + this.props.collapse,
                label: "/Spend/Presentational/SelectedCharities",
              });
              this.props.onToggleCollapse();
            }}
          >
            <FontAwesomeIcon
              className={styles.icon}
              icon={this.props.collapse ? faChevronUp : faChevronDown}
            />
          </button>
        </div>
      </div>
    );
  }
}
